import React ,{useState} from "react";
import moment from "moment-jalaali";
import QRCode from "react-qr-code";
import { Popconfirm, message ,Spin} from 'antd';


const ConvertToJalaliSplited = (date) =>{
    if(date){
        let month = moment.utc(date.split('+')[0]).format('jMM');
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        return year+"-"+month+"-"+day
    }
    return ""
}

const DiscountPercentCard = ({item,final})=>{
    const [consumed,set_consumed] = useState(false)
    const [spin,set_spin] = useState(false)

    function confirm(e) {
        //final(item.code)
        setFinal()
    }

    function cancel(e) {
    }

    async function setFinal(){
        set_spin(true)
        const res = await final(item.code)
        set_spin(false)

        if(res)
            set_consumed(true)
    }

   return(

       <div key={item.uid} className="slider-gift-section" style={{width:"100%"}}>
           <Popconfirm
               title="بعد از انتخاب و اعمال کوپن در صورت خروج از صفحه پرداخت و یا برگشت به صفحه قبل , کوپن مورد نظر نامعتبر خواهد شد."
               onConfirm={confirm}
               onCancel={cancel}
               okText="استفاده"
               icon={""}
               cancelText="انصراف"
           >
               <Spin spinning={spin}>
                   <div className="gift-section-ticket">
                       {!consumed?<div className="gift-section-ticket-off reward_level_2 reward_level_3">
                           {/*<QRCode size={64} value={item.code} />*/}
                           <span>برای استفاده</span>
                           <span>انتخاب کنید</span>
                       </div>:<div className="gift-section-ticket-off  reward_level_3 consumed-coupon">
                           {/*<QRCode size={64} value={item.code} />*/}
                           <span>استفاده شده</span>
                       </div>}

                       <div className="gift-section-ticket-info" style={{justifyContent:"flex-start",paddingRight:30}}>
                           <div className="rotated-half-up-circle"></div>
                           <div className="rotated-half-down-circle"></div>
                           <span
                               className="gift-section-ticket-info-title" style={{fontSize:14}}>{item.campaign_title}</span>
                           {/*<span className="gift-section-ticket-info-max">{item.code}</span>*/}
                           <div className="gift-section-ticket-info-date" style={{direction:"rtl",flexDirection:"column"}}>

                               <div style={{color:"#009587",fontSize: 20,fontFamily:'YekanBold'}}>
                                   <span><span>{item.discount_value ? item.discount_value : " 0 "}</span>%</span>
                                   <span> تخفیف </span>
                               </div>

                               <div style={{fontSize:10}}>
                                   <div> از تاریخ  {ConvertToJalaliSplited(item.valid_from_date)} </div>
                                   <div> تا تاریخ {ConvertToJalaliSplited(item.valid_to_date)}</div>
                               </div>
                               {/*<div style={{display:'flex',flexDirection:"column"}}>*/}
                               {/*    <span className="coupon_date"> از تاریخ  {ConvertToJalaliSplited(item.valid_from_date)} </span>*/}
                               {/*    <span className="coupon_date"> تا تاریخ {ConvertToJalaliSplited(item.valid_to_date)}</span>*/}
                               {/*</div>*/}
                               {/*<span>{ConvertToJalaliSplited(coupon.valid_to_date)}</span>*/}
                           </div>
                       </div>
                   </div>
               </Spin>
           </Popconfirm>

       </div>
   )
}





const DiscountAmountCard = ({item,final})=>{
    const [consumed,set_consumed] = useState(false)
    const [spin,set_spin] = useState(false)


    function confirm(e) {
        //final(item.code)
        setFinal()
    }

    function cancel(e) {
    }

    async function setFinal(){
        set_spin(true)
        const res = await final(item.code)
        set_spin(false)
    }

    return(

        <div key={item.uid} className="slider-gift-section" style={{width:"100%"}}>
            <Popconfirm
                title="بعد از انتخاب و اعمال کوپن در صورت خروج از صفحه پرداخت و یا برگشت به صفحه قبل , کوپن مورد نظر نامعتبر خواهد شد."
                onConfirm={confirm}
                onCancel={cancel}
                okText="استفاده"
                icon={""}
                cancelText="انصراف"
            >
                <Spin spinning={spin}>
                    <div className="gift-section-ticket">

                        <div className="gift-section-ticket-off reward_level_2">
                            <QRCode size={64} value={item.code} />
                        </div>

                        <div className="gift-section-ticket-info" style={{justifyContent:"flex-start",paddingRight:30}}>
                            <div className="rotated-half-up-circle"></div>
                            <div className="rotated-half-down-circle"></div>
                            <span
                                className="gift-section-ticket-info-title" style={{fontSize:14}}>{item.campaign_title}</span>
                            {/*<span className="gift-section-ticket-info-max">{item.code}</span>*/}
                            <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                                <div style={{display:'flex',flexDirection:"column"}}>
                                    <div style={{color:"#009587",fontSize: 20,fontFamily:'YekanBold'}}>
                                        <span >{item.discount_value ? item.discount_value/1000 : " 0 "}</span>
                                        <span> هزار ریال </span>
                                    </div>
                                    <div style={{fontSize:10}}>
                                        <div> از تاریخ  {ConvertToJalaliSplited(item.valid_from_date)} </div>
                                        <div> تا تاریخ {ConvertToJalaliSplited(item.valid_to_date)}</div>
                                    </div>
                                </div>
                                {/*<span>{ConvertToJalaliSplited(coupon.valid_to_date)}</span>*/}
                            </div>
                        </div>
                    </div>
                </Spin>
            </Popconfirm>

        </div>
    )
}




const RewardItemCard = ({item,final})=>{
    const [consumed,set_consumed] = useState(false)
    const [spin,set_spin] = useState(false)


    function confirm(e) {
        //final(item.code)
        setFinal()
    }

    function cancel(e) {
    }

    async function setFinal(){
        set_spin(true)
        const res = await final(item.code)
        set_spin(false)
    }

    return(

        <div key={item.uid} className="slider-gift-section" style={{width:"100%"}}>
            <Popconfirm
                title="بعد از انتخاب و اعمال کوپن در صورت خروج از صفحه پرداخت و یا برگشت به صفحه قبل , کوپن مورد نظر نامعتبر خواهد شد."
                onConfirm={confirm}
                onCancel={cancel}
                okText="استفاده"
                icon={""}
                cancelText="انصراف"
            >
                <Spin spinning={spin}>
                    <div className="gift-section-ticket">

                        <div className="gift-section-ticket-off reward_level_2">
                                                <span className="gift-section-ticket-off-number"><span
                                                    className="off-number">{item.discount_value ? item.discount_value : " 0 "}</span></span>
                            <span className="gift-section-ticket-off-label">  </span>
                        </div>

                        <div className="gift-section-ticket-info">
                            <div className="rotated-half-up-circle"></div>
                            <div className="rotated-half-down-circle"></div>
                            <span
                                className="gift-section-ticket-info-title" style={{paddingRight: 11,fontSize:14}}>{item.campaign_title}</span>
                            {/*<span className="gift-section-ticket-info-max">{item.code}</span>*/}
                            <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                                <div style={{display:'flex',flexDirection:"column"}}>
                                    <span className="coupon_date"> از تاریخ  {ConvertToJalaliSplited(item.valid_from_date)} </span>
                                    <span className="coupon_date"> تا تاریخ {ConvertToJalaliSplited(item.valid_to_date)}</span>
                                </div>
                                {/*<span>{ConvertToJalaliSplited(coupon.valid_to_date)}</span>*/}
                            </div>
                        </div>
                    </div>
                </Spin>
            </Popconfirm>

        </div>
    )
}




const CouponComponent = ({item,final})=>{

    switch (item.coupon_type) {
        case 'discount_percent':
            return(
                <DiscountPercentCard item={item} final={final} />
            )

            break;
        case 'discount_amount':
            return(
                <DiscountAmountCard item={item} final={final} />
            )
            break;
        case 'reward_item':
            return(
                <RewardItemCard item={item} final={final} />
            )
            break;
    }
}

export default CouponComponent;
